var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('b-table',{attrs:{"items":_vm.groups,"fields":_vm.fields,"selectable":"","select-mode":"single","primary-key":"_id"},on:{"row-selected":_vm.rowSelection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }